import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { http, fmtErr } from "@/lib/api";
import { useGuest } from "@/context/GuestContext";
import { Star } from "lucide-react";
import { toast } from "sonner";

export default function GuestFeedbackPage() {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [publish, setPublish] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const { logout } = useGuest();
  const nav = useNavigate();

  const submit = async () => {
    setBusy(true);
    try {
      await http.post("/guest/feedback", { rating, comment, permission_to_publish: publish });
      setDone(true);
      setTimeout(async () => { await logout(); nav("/"); }, 2500);
    } catch (e) { toast.error(fmtErr(e)); } finally { setBusy(false); }
  };

  if (done) return (
    <div className="min-h-screen flex items-center justify-center text-center p-8" style={{ background: "var(--surface)" }}>
      <div>
        <h1 className="font-serif text-5xl mb-4">Thank you.</h1>
        <p style={{ color: "var(--muted)" }}>Safe travels — we hope to see you again in the pines.</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen p-4 flex items-center" style={{ background: "var(--surface)" }}>
      <div className="max-w-lg mx-auto w-full">
        <div className="eyebrow mb-2">Feedback</div>
        <h1 className="font-serif text-4xl mb-6">How was your stay?</h1>
        <div className="card">
          <div className="flex gap-2 mb-5 justify-center">
            {[1, 2, 3, 4, 5].map((n) => (
              <button key={n} data-testid={`feedback-star-${n}`} onClick={() => setRating(n)}>
                <Star size={38} fill={n <= rating ? "var(--terracotta)" : "none"} color={n <= rating ? "var(--terracotta)" : "var(--muted)"} />
              </button>
            ))}
          </div>
          <textarea data-testid="feedback-comment" rows="4" placeholder="Tell us what you loved (or what we can improve)…" value={comment} onChange={(e) => setComment(e.target.value)} className="mb-4" />
          <label className="flex items-center gap-2 text-sm mb-4"><input type="checkbox" style={{ width: "auto" }} data-testid="feedback-publish" checked={publish} onChange={(e) => setPublish(e.target.checked)} /> Allow us to publish this review</label>
          <button data-testid="feedback-submit" onClick={submit} disabled={busy} className="btn-primary w-full">{busy ? "Sending…" : "Share Feedback"}</button>
        </div>
      </div>
    </div>
  );
}
